




import { Component, Vue } from "vue-property-decorator";
@Component
export default class CmsContent extends Vue {
  data() {
    const component = this;

    return {
      get isViewingCmsContent() {
        return component.$authRepository.isViewingCmsContent();
      },
      set isViewingCmsContent(value) {
        if (value) {
          component.$authRepository.enableViewingCmsContent();
        } else {
          component.$authRepository.disableViewingCmsContent();
        }
      }
    };
  }
}
